<div *ngIf="!detalleConjunto">
    <div class="title">
        <h3> <strong>Información de la Propiedad:</strong> </h3>
    </div>
    <div class="container cont div-box-shadow">
        <div class="row">
            <div class="col-md-4 info">
                Rol:
            </div>
            <div class="col-md-6">
                {{ infoDetalle.rol }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row" *ngFor="let dir of direcciones">
            <div class="col-md-4 info">
                Dirección:
            </div>
            <div class="col-md-6">
                {{ dir['Calles 4::Calles_Nombre'] }} {{ dir['Propiedad_Direccion::PD_Num'] }} {{
                dir['Propiedad_Direccion::PD_Tipo_Complem'] }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Manzana:
            </div>
            <div class="col-md-6">
                {{ infoDetalle.info.fieldData.Pro_Manzana }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Lote:
            </div>
            <div class="col-md-6">
                {{ infoDetalle.info.fieldData.Pro_Lote_Predial }}
            </div>
            <hr style="border-top: 1px solid">
        </div>
        <div class="row">
            <div class="col-md-4 info">
                Conjunto:
            </div>
            <div class="col-md-6">
                {{ infoDetalle.info.fieldData['Conjunto_Habitacional::ConjHab_Nombre_Completo'] }} <a
                    style="cursor: pointer;" (click)="detalleConjunto = !detalleConjunto">Ver Conjunto
                </a>
            </div>
            <hr style="border-top: 1px solid">
        </div>
    </div>
</div>
<div *ngIf="detalleConjunto">
    <app-detalle-totem [detalleDir]="infoDetalle"></app-detalle-totem>
</div>